import React from "react";
import ContentRouter from "../../router/dashboard";

const Dashboard = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <ContentRouter />
    </div>
  );
};

export default Dashboard;
